import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PolicyCN = ({ user, onAcknowledge }) => {
  const navigate = useNavigate();
  const [ackSubmitting, setAckSubmitting] = useState(false);
  const langBtnStyle = { backgroundColor: '#e3f2fd', color: '#1565c0', border: '1px solid #90caf9', padding: '8px 16px', borderRadius: '6px', textDecoration: 'none', fontWeight: 500, display: 'inline-block' };

  const handleAcknowledge = async () => {
    if (!user || !onAcknowledge) return;
    setAckSubmitting(true);
    try {
      await onAcknowledge();
      navigate('/', { replace: true });
    } finally {
      setAckSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <div className="card">
        <div style={{ marginBottom: '20px' }}>
          <Link to="/policy/en" style={langBtnStyle}>English</Link>
        </div>
        <h1>课程报名协议（中文）</h1>
        <p style={{ color: '#666', marginBottom: '30px' }}>最后更新：{new Date().toLocaleDateString('zh-CN', { timeZone: 'America/Los_Angeles' })}</p>

        <section style={{ marginBottom: '30px' }}>
          <p>报名前请仔细阅读以下条款。</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>1. 课时有效期</h2>
          <p>每4节课为一个课包，需在6周内完成。未在有效期内完成的剩余课时将自动作废。</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>2. 请假政策</h2>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>如需请假或改期，请至少提前24小时通知老师；否则该课时将视为已上。</li>
            <li>每个课包最多允许1次请假补课，补课须在课包有效期内完成。</li>
          </ul>
          <h3 style={{ marginTop: '20px' }}>临时病假说明</h3>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>如因突发身体不适或疾病，在临近上课前临时请假，请第一时间告知老师。该情况下将保留半节课（0.5节）课时 credit，每个课包仅限一次，不可累计使用。</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>3. 退课政策</h2>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>课程开始前7天（一周）可申请全额退费。</li>
            <li>课程开始后不提供退费。</li>
            <li>开课后未使用的课时可转让给他人或顺延至下一个课包（仅限一次）。</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>4. 开课后的换课安排</h2>
          <p>课程开始后如需调整上课时间，请提前与老师沟通，是否可换课将视课程安排情况而定。</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>5. 其他事项</h2>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>本工作室为小班制教学。为保证教学质量，请学员遵守既定课程安排及所有相关规则。</li>
            <li>如遇特殊情况，请及时与老师沟通。老师将在不违背工作室规则及课程安排的前提下，尽力提供合理的解决方案。</li>
          </ul>
        </section>

        <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #ddd', display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
          {user && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAcknowledge}
              disabled={ackSubmitting || user.policy_acknowledged_at}
            >
              {user.policy_acknowledged_at ? '已确认政策' : ackSubmitting ? '保存中…' : '我已阅读并同意以上条款'}
            </button>
          )}
          <Link to="/register" className="btn btn-secondary">返回注册</Link>
        </div>
      </div>
    </div>
  );
};

export default PolicyCN;
